import { render, staticRenderFns } from "./TambienCompraron.vue?vue&type=template&id=a6728926&"
import script from "./TambienCompraron.vue?vue&type=script&lang=js&"
export * from "./TambienCompraron.vue?vue&type=script&lang=js&"
import style0 from "./TambienCompraron.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports